import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";

export default function GamingiGamingLicenseSeychelles (){

    return (
        <main className='main'>

            <IntroSection
                title="Gaming & iGaming License – Seychelles"
                subtitle="Operate Online Casinos, Sportsbooks & Lotteries in the Indian Ocean"
                description =
                    "
                    <b>Seychelles</b> offers <b>licenses for online gaming, sports betting, lottery operations, and retail betting shops</b>, regulated by the <b>Financial Services Authority (FSA)</b>.
                    <br/>
                    While not as widely recognized as <b>Malta</b>, <b>Isle of Man</b>, or <b>Curacao</b>, <b>Seychelles gaming licenses</b> provide <b>regional legitimacy</b>, <b>tax neutrality</b>, and <b>cost efficiency</b> — making it suitable for <b>emerging operators</b>.
                    "
                badges={
                    [
                        "Online Casinos",
                        "Sports Betting",
                        "Lotteries",
                        "Retail Betting"
                    ]
                }
                buttonText="Request a Seychelles Gaming Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gaming-igaming-license–seychelles-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Seychelles for Gaming?'
                        blocks={[
                            {
                                items:
                                    [
                                        { title: "Government-Regulated", text: "FSA oversight adds legitimacy" },
                                        { title: "Multiple License Classes", text: "online, retail, sports betting, and lotteries" },
                                        { title: "Cost-Efficient", text: "cheaper than Malta/Isle of Man" },
                                        { title: "Tax Neutrality", text: "no tax on foreign-sourced gaming income" },
                                        { title: "Regional Markets", text: "strong for Africa & Asia-facing operators" }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Gaming Licenses in Seychelles"
                        blocks={[
                            {
                                title: "Online Casino License",
                                items:
                                    [
                                        { text: "Covers slots, table games, poker, and RNG-based platforms" },
                                        { text: "Can include white-label and B2B game providers" }
                                    ]
                            },
                            {
                                title: "Sports Betting License",
                                items:
                                    [
                                        { text: "Retail betting shops and online sportsbook platforms" },
                                        { text: "Includes live odds, in-play betting, and esports" }
                                    ]
                            },
                            {
                                title: "Lottery License",
                                items:
                                    [
                                        { text: "National or private lotteries" },
                                        { text: "Charity and promotional lottery operations" }
                                    ]
                            },
                            {
                                title: "Retail Gaming & Betting License",
                                items:
                                    [
                                        { text: "Covers betting shops, kiosks, and gaming centers" },
                                        { text: "Ideal for regional operators in Africa/Asia" }
                                    ]
                            },

                        ]}
                    />


                    <FeatureCards
                        title='Capital & Requirements'
                        features={
                            [
                                { title: "Minimum Capital", text: "USD 50,000–150,000 depending on activity" },
                                { title: "Entity Incorporation", text: "Seychelles IBC or local company required" },
                                { title: "Resident Director & Compliance Officer", text: "mandatory" },
                                { title: "AML/KYC Policies", text: "aligned with FATF standards" },
                                { title: "Local Hosting", text: "some activities may require Seychelles-based servers" }
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Benefits of a Seychelles Gaming License'
                        item={
                            [
                                { title: "Legitimate Regulation", text: "supervised by FSA" },
                                { title: "Online + Retail Coverage", text: "casinos, sportsbooks, lotteries" },
                                { title: "Banking Access", text: "more credibility than unlicensed offshore setups" },
                                { title: "Lower Entry Barriers", text: "cheaper and faster than Tier-1 regulators" },
                                { title: "Hybrid Models", text: "online + land-based expansion possible" }
                            ]
                        }
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                { title: "Pre-Application Consultation", text: "define business scope (casino, betting, lottery)" },
                                { title: "Company Incorporation", text: "register a Seychelles IBC" },
                                { title: "Application Preparation", text: "business plan, AML/KYC, game provider agreements" },
                                { title: "FSA Review", text: "regulator due diligence" },
                                { title: "Approval & Licensing", text: "typically 6–9 months" }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: " 6-9 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 60,000+ (legal, compliance, licensing)",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 50k–150k depending on license type",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Costs",
                                description: "FSA fees, compliance reporting, audits",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in gaming & betting licenses worldwide" },
                                { text: "End-to-end support: incorporation, FSA filing, compliance" },
                                { text: "Partnerships with PSPs, game providers, and hosting firms" },
                                { text: "Balanced insights: Seychelles vs Curacao vs Malta vs Western Sahara" },
                                { text: "Long-term compliance & audit support" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                            "
                                Looking to launch a casino, sportsbook, or lottery?
                            "
                         description=
                             "
                                <b>Seychelles</b> offers <b>gaming licenses</b> under <b>FSA regulation</b>, with <b>cost-effective setup</b> and <b>tax neutrality</b>.
                             "
                         buttonText='Book a Seychelles Gaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is a Seychelles gaming license globally recognized?",
        content: [
            { type: "answer", text: "Not as strong as Malta or Curacao, but valid for Africa/Asia-facing markets." },
        ],
    },
    {
        question: "What’s the capital requirement?",
        content: [
            { type: "answer", text: "USD 50k–150k depending on license type." },
        ],
    },
    {
        question: "Can I operate an online casino from Seychelles?",
        content: [
            { type: "answer", text: "Yes — with FSA approval and proper compliance." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Around 6–9 months." },
        ],
    },
    {
        question: "Why choose Seychelles over Curacao?",
        content: [
            { type: "answer", text: "Lower costs, government legitimacy — but less international recognition." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We licensed our sportsbook in Seychelles. Offshore Advisory made the FSA process smooth and banking-friendly.",
            author: "Martin K.",
            role: "Betting Operator"
        },
        {
            quote: "Seychelles was ideal for our lottery and gaming startup. Offshore Advisory handled incorporation, license filing, and compliance.",
            author: "Elena P.",
            role: "Lottery Entrepreneur"
        }
    ]
;